import React from "react";
//#region types
import { ContentCardProps } from "models/propTypes/contentTreePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import ContentTreeNode from "./contentTreeNode";
import StaticInfoMessage from "../messages/staticInfoMessage";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ContentCard: React.FC<ContentCardProps> = (props) => {
  const { contentTree, currentIndex } = props;

  return (
    <Grid container className={cssExports.contentTreeContainer} direction="row">
      <Grid item xs>
        {contentTree.mainText !== undefined && (
          <Grid container item className={cssExports.title} rowSpacing={4} direction="row" wrap="nowrap">
            <Grid item className={cssExports.indexTitle}>
              {currentIndex + 1}
            </Grid>
            <Grid item xs>
              {contentTree.mainText}
            </Grid>
          </Grid>
        )}
        <ContentTreeNode nodes={contentTree.subTree} parentIndex={currentIndex + 1} />
      </Grid>

      <Grid item className={cssExports.bubble}>
        {contentTree.messageBubbles !== undefined &&
          contentTree.messageBubbles.map((messageBubble, messageBubbleIndex) => (
            <StaticInfoMessage key={`bubble-${messageBubbleIndex}`} {...messageBubble} hideIcon gutterBottom>
              <Grid item xs className={cssExports.message}>
                {messageBubble.children}
              </Grid>
            </StaticInfoMessage>
          ))}
      </Grid>
    </Grid>
  );
};

export default ContentCard;
